<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer001">
<p class="structure-next" id="calibre_pb_7"> </p>
<p class="basic-paragraph"><span class="charoverride1"> </span></p>
<p class="basic-paragraph"><span class="charoverride1">Also by Irene O’Garden</span></p>
<p class="body_quote"><span class="charoverride2">Risking the Rapids: How My Wilderness Adventure Healed My</span><span class="nobreak"><span class="charoverride2"> </span></span><span class="nobreak"><span class="charoverride2">Childhood</span></span></p>
<p class="body_quote"><span class="charoverride2">Fat Girl: One Woman</span><span class="nobreak"><span class="charoverride2">’s Way</span></span><span class="nobreak"><span class="charoverride2"> </span></span><span class="nobreak"><span class="charoverride2">Out</span></span></p>
<p class="body_quote"><span class="charoverride2">Fulcrum: Sele</span><span class="nobreak"><span class="charoverride2">cted</span></span><span class="nobreak"><span class="charoverride2"> </span></span><span class="nobreak"><span class="charoverride2">Poems</span></span></p>
<p class="body_quote"><span class="charoverride2">Women on F</span><span class="nobreak"><span class="charoverride2">ire (play)</span></span></p>
<p class="basic-paragraph"><span class="charoverride1"> </span></p>
<p class="basic-paragraph"><span class="charoverride1">For Children</span></p>
<p class="body_quote"><span class="charoverride2">May</span><span class="nobreak"><span class="charoverride2">be My</span></span><span class="nobreak"><span class="charoverride2"> </span></span><span class="nobreak"><span class="charoverride2">Baby</span></span></p>
<p class="body_quote"><span class="charoverride2">The Scrubbly Bubbl</span><span class="nobreak"><span class="charoverride2">y Car</span></span><span class="nobreak"><span class="charoverride2"> </span></span><span class="nobreak"><span class="charoverride2">Wash</span></span></p>
<p class="body_quote"><span class="charoverride2">Forest, What Would</span><span class="nobreak"><span class="charoverride2"> You Like?</span></span></p>
</div>
<div class="basic-text-frame" id="_idContainer003">
<div class="calibre1" id="calibre_pb_8"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GladtoBeHuman_split_003.vue?d9d67df6